import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import SupplierOverviewService from 'src/modules/3rd-party-management/apis/admin/SupplierOverviewService';

const useCreatePackagingProductRiskAndTask = ({
    supplierId,
    t,
    onSuccess,
}) => {
    return useMutation({
        mutationFn: async ({ productId }) => {
            const service = SupplierOverviewService.getInstance();

            return await service.createPackagingProductRiskAndTask(supplierId, productId);
        },
        onSuccess: (data, variables) => {
            toast(t('Risk and task created successfully.'), {
                type: 'success',
            });

            onSuccess?.(data, variables);
        },
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while creating the risk and task.'), {
                type: 'error',
            });
        },
    });
};

export default useCreatePackagingProductRiskAndTask;
